import { createSlice, current } from '@reduxjs/toolkit';
import {
	getDocumentTypeList,
	getDocumentType,
	addNewDocumentType,
	updateDocumentType,
	deleteDocumentType,
	checkDocumentTypeExists,
} from './thunk';

export const initialState = {
	itemDocumentTypeList: [],
	itemDocumentType: null,
	isDocumentTypeLoading: false,
	isDocumentTypeSuccess: false,
	dataDocumentType: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const DocumentTypeSlice = createSlice({
	name: 'DocumentType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getDocumentTypeList.pending, state => {
			state.isLoadingList = true;
			state.isDocumentTypeSuccess = false;
		});

		builder.addCase(getDocumentTypeList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemDocumentTypeList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isDocumentTypeSuccess = true;
		});

		builder.addCase(getDocumentTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDocumentTypeSuccess = false;
		});

		builder.addCase(getDocumentType.pending, state => {
			state.isDocumentTypeLoading = true;
			state.isDocumentTypeSuccess = false;
		});

		builder.addCase(getDocumentType.fulfilled, (state, action) => {
			state.itemDocumentType = action.payload;
			state.isDocumentTypeLoading = false;
			state.isDocumentTypeSuccess = true;
		});

		builder.addCase(getDocumentType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDocumentTypeLoading = false;
			state.isDocumentTypeSuccess = false;
		});

		builder.addCase(addNewDocumentType.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewDocumentType.fulfilled, (state, action) => {
			state.itemDocumentTypeList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewDocumentType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateDocumentType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateDocumentType.fulfilled, (state, action) => {
			state.itemDocumentTypeList = state.itemDocumentTypeList.map(
				documentTypeList =>
					documentTypeList._id.toString() === action.payload._id.toString()
						? { ...documentTypeList, ...action.payload }
						: documentTypeList
			);
			state.statementList = state.statementList.map(documentTypeList =>
				documentTypeList._id.toString() === action.payload._id.toString()
					? { ...documentTypeList, ...action.payload }
					: documentTypeList
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateDocumentType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteDocumentType.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteDocumentType.fulfilled, (state, action) => {
			state.itemDocumentTypeList = current(
				state.itemDocumentTypeList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteDocumentType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkDocumentTypeExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkDocumentTypeExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkDocumentTypeExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = DocumentTypeSlice.actions;

export default DocumentTypeSlice.reducer;
